function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import parseBindings, { MODE_HANDLE } from './parseBindings';

var BindingManager = /*#__PURE__*/function () {
  function BindingManager(client, element) {
    _classCallCheck(this, BindingManager);

    this.client = client;
    this.element = element;
    this._handlers = new Map();
    this.update();
  }

  _createClass(BindingManager, [{
    key: "update",
    value: function update() {
      var targetBindings = this._parseBindings();

      this._removeExtraHandlers(targetBindings);

      this._setupMissingHandlers(targetBindings);
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      var _iterator = _createForOfIteratorHelper(this._handlers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var eventName = _ref2[0];
          var callback = _ref2[1];
          this.element.removeEventListener(eventName, callback);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._handlers.clear();
    }
  }, {
    key: "_parseBindings",
    value: function _parseBindings() {
      var motionAttribute = this.client.motionAttribute;
      var bindingsString = this.element.getAttribute(motionAttribute);
      var bindings = new Map();

      var _iterator2 = _createForOfIteratorHelper(parseBindings(bindingsString, this.element)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var binding = _step2.value;
          bindings.set(binding.id, binding);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return bindings;
    }
  }, {
    key: "_buildHandlerForBinding",
    value: function _buildHandlerForBinding(_ref4) {
      var _this = this;

      var mode = _ref4.mode,
          motion = _ref4.motion;
      return function (event) {
        var component = _this._getComponent();

        if (component && component.processMotion(motion, event, _this.element) && mode === MODE_HANDLE) {
          event.preventDefault();
        }
      };
    }
  }, {
    key: "_getComponent",
    value: function _getComponent() {
      return this.client.getComponent(this.element);
    }
  }, {
    key: "_setupMissingHandlers",
    value: function _setupMissingHandlers(targetBindings) {
      var _iterator3 = _createForOfIteratorHelper(targetBindings.entries()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref7 = _step3.value;

          var _ref6 = _slicedToArray(_ref7, 2);

          var id = _ref6[0];
          var binding = _ref6[1];

          if (!this._handlers.has(id)) {
            var event = binding.event;

            var handler = this._buildHandlerForBinding(binding);

            this.element.addEventListener(event, handler);

            this._handlers.set(id, [event, handler]);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "_removeExtraHandlers",
    value: function _removeExtraHandlers(targetBindings) {
      var _iterator4 = _createForOfIteratorHelper(this._handlers.entries()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref10 = _step4.value;

          var _ref9 = _slicedToArray(_ref10, 2);

          var id = _ref9[0];

          var _ref9$ = _slicedToArray(_ref9[1], 2);

          var event = _ref9$[0];
          var callback = _ref9$[1];

          if (!targetBindings.has(id)) {
            this.element.removeEventListener(event, callback);

            this._handlers.delete(id);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }]);

  return BindingManager;
}();

export { BindingManager as default };